import Mesh from './Mesh';
import TransformVertices from './TransformVertices';
import MeshSmooth from './MeshSmooth';
import UVMap from './UVMap';
import UVTransform from './UVTransform';
import Skin from './Skin';
import Box from './Box';
import Sphere from './Sphere';
import Cone from './Cone';
import Capsule from './Capsule';
import Cylinder from './Cylinder';
import Plane from './Plane';
import Torus from './Torus';
import Disk from './Disk';
import ProxyMesh from './ProxyMesh';
import Instance from './Instance';
import SortFacesByAxis from './SortFacesByAxis';

export default { Mesh, MeshSmooth, Skin, TransformVertices, UVMap, UVTransform, Box, Sphere,
  Cone, Capsule, Cylinder, Plane, Torus, Disk, ProxyMesh, Instance, SortFacesByAxis, };



// WEBPACK FOOTER //
// ./src/operators/PolyMesh/index.js